export default __webpack_public_path__ + "static/media/arystrach.36b995f1.png";